import ReactOnRails from 'react-on-rails';

import Pivot from '../bundles/HelloWorld/components/Pivot';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  Pivot,
});
